import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import GetYourFreeQuote from "./sections/GetYourFreeQuote";
import CommonQuestions from "./sections/CommonQuestions";
import OurLocation from "./sections/OurLocation";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <GetYourFreeQuote />
      <CommonQuestions />
      <OurLocation />
      <Footer />
    </div>;
}